import { render, staticRenderFns } from "./ActivityConfig.vue?vue&type=template&id=176e021c"
import script from "./ActivityConfig.vue?vue&type=script&lang=js"
export * from "./ActivityConfig.vue?vue&type=script&lang=js"
import style0 from "./ActivityConfig.vue?vue&type=style&index=0&id=176e021c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports